







































import { Component, Vue, Prop } from "vue-property-decorator";
import { JobItem } from "../../common/interfaces";
import store from "@/store/store";
import moment from "moment";
import axios from "axios";

@Component({})
export default class UpcomingJob extends Vue {
  @Prop()
  public job: JobItem;
  protected dateBeforeSave: moment.Moment | undefined;
  // using a second variable to display the booked in date as if you use the job object
  // the list re-sorts before saving the line.
  protected displayBookedInDate: moment.Moment | undefined = moment();

  public created() {
    this.displayBookedInDate = this.job.BookedInDateTime
      ? moment(this.job.BookedInDateTime)
      : undefined;
    this.dateBeforeSave = this.job.BookedInDateTime
      ? moment(this.job.BookedInDateTime)
      : undefined;
  }

  get fullDescription() {
    return `(${this.job.JobId}) ${this.job.TypeDescription}`;
  }

  get divisionDescription() {
    return this.job.ContactId
      ? `${this.job.DivisionName} (${this.job.AddressPostcode})`
      : null;
  }

  get displayDueDate() {
    return this.job.DueDate && this.job.DueDate.isValid()
      ? this.job.DueDate.format("DD-MMM-YYYY")
      : "No Date";
  }

  public displayDate(date: moment.Moment) {
    return date.isValid() ? date.format("DD-MMM-YYYY") : "No Date";
  }

  public async bookingDateChanged(newDate: string) {
    this.displayBookedInDate = moment(newDate);
  }

  public selectJob() {
    this.$router.push(`/Job/${this.job.JobId}`);
  }

  public async saveBookingDate() {
    const currentBookedInDateTime = this.job!.BookedInDateTime;
    const bookedInDateTime: moment.Moment = moment(this.displayBookedInDate);
    bookedInDateTime.set({
      hour: currentBookedInDateTime ? currentBookedInDateTime.get("hour") : 0,
      minute: currentBookedInDateTime
        ? currentBookedInDateTime.get("minute")
        : 0
    });

    if (
      (this.displayBookedInDate === undefined && this.dateBeforeSave) ||
      (this.displayBookedInDate &&
        !this.displayBookedInDate.isSame(this.dateBeforeSave))
    ) {
      const updateObject = {
        BookedInDateTime: bookedInDateTime
      };

      try {
        const response = await axios.patch(
          `${store.state.Environment.ODataBaseUrl}/ProblemXtras(${this.job.JobId})`,
          updateObject,
          {
            headers: {
              Authorization: "Bearer " + store.state.User.AccessToken
            }
          }
        );
        this.$root.$emit("refreshJobList");
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: "Failed update booked in date",
          offset: 48
        });
      }
    }
  }
}
